import { StringFeatureToggleOptions } from 'Common/appshell_types/featureToggles';

export const exposeStringFeatureToggleOptions = () => StringFeatureToggleOptions;
